export enum AssetSource {
  QUICK_START = 'quick-start',
  DOCUMENTATION = 'documentation',
}
